import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { useNewProjectUrl, useProjectDataContext } from 'domain/shared/newProject';
import DashboardBreadcrumbs from '../../shared/breadcrumbs/DashboardBreadcrumbs';

const SummaryReviewBreadcrumbs = () => {
  const { data: project } = useProjectDataContext();
  const { getControlsUrl } = useNewProjectUrl();

  return (
    <DashboardBreadcrumbs>
      <ListBreadcrumbItem entity={project.name || EMPTY_VALUE_INDICATOR} link={getControlsUrl(project.id)} />
      <ListBreadcrumbItem entity="Review Summary" />
    </DashboardBreadcrumbs>
  );
};

export default SummaryReviewBreadcrumbs;
